export default __webpack_public_path__ + "1c846285a9bf1459be4f033f4039b786.png";